import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zhTranslation from './locales/zh/translation.json';
import enTranslation from './locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

      resources: {
          zh: {
              translation: zhTranslation
          },
          en: {
              translation: enTranslation
          }
      }
  });

// Expose t/i18n as globals so any component (or legacy helper) can call t('...')
// without a per-file useTranslation import. Components still call the hook for
// reactivity; this is a safety net that also keeps the build green (no-undef).
if (typeof window !== 'undefined') {
  window.t = (key, options) => i18n.t(key, options);
  window.i18n = i18n;
}

export default i18n;
